import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { getSnackbarStore } from 'stores/SnackBarStore';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity
    }
  },
  queryCache: new QueryCache({
    onError: (_, query) => {
      if (query.meta?.snackbarErrorMessage) {
        getSnackbarStore().showErrorSnackbarMessage(query.meta.snackbarErrorMessage as string);
      }
    },
    onSuccess: (_, query) => {
      if (query.meta?.snackbarSuccessMessage) {
        getSnackbarStore().showSuccessSnackbarMessage(query.meta.snackbarSuccessMessage as string);
      }
    }
  }),
  mutationCache: new MutationCache({
    onError: (_, variables, context, mutation) => {
      if (mutation.meta?.snackbarErrorMessage) {
        getSnackbarStore().showErrorSnackbarMessage(mutation.meta.snackbarErrorMessage as string);
      }
    },
    onSuccess: (_, variables, context, mutation) => {
      if (mutation.meta?.snackbarSuccessMessage) {
        getSnackbarStore().showSuccessSnackbarMessage(mutation.meta.snackbarSuccessMessage as string);
      }
    }
  })
});
